import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Progress } from '@dojo/widgets/progress';
import css from '../css/progress.m.css';
const factory = create({
    theme
}).properties();
export const MicroProgress = factory(({ id: widgetId, properties, middleware: { theme } }) => {
    const { aria, min = 0, max = 100, value = 0, showLabel = true, label, showOutput = true, output } = properties();
    const fixedCss = theme.classes(css);
    const overrides = {
        '@dojo/widgets/progress': {
            root: [fixedCss.progress]
        }
    };
    return v('div', { id: widgetId, classes: [fixedCss.root] }, [
        v('div', { classes: [fixedCss.flexContainer] }, [
            v('div', { classes: [fixedCss.label] }, [showLabel ? (label ? label : `${value}/${max}`) : '']),
            v('div', { classes: [fixedCss.output] }, [
                showOutput ? (output ? output : `${Math.round((value / max) * 100)}%`) : ''
            ])
        ]),
        w(Progress, {
            widgetId: `${widgetId}-progress`,
            aria,
            min,
            max,
            value,
            showOutput: false,
            classes: overrides
        })
    ]);
});
export default MicroProgress;
